(function () {
    'use strict';
    ImageGalleryManagerV2Controller.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', 'ImageData', 'ImageDataExtended', '$mdDialog', '$uibModal'];

    function ImageGalleryManagerV2Controller($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, ImageData, ImageDataExtended, $mdDialog, $uibModal) {
//
        var $ctrl = this;
        $ctrl.keep_aspect = this.keepAspect || true;
        $ctrl.disableCropping = false || this.disableCropping;
        $ctrl.maxImageCount = this.maxImageCount || 10;
        $ctrl.cropWidth = this.cropWidth || 200;
        $ctrl.cropHeight = this.cropHeight || 200;
        $ctrl.minHeight = this.minHeight || $ctrl.cropHeight;
        $ctrl.minWidth = this.minWidth || $ctrl.cropWidth;
        $ctrl.bounds = {};
        $ctrl.bounds.left = 0;
        $ctrl.bounds.right = 0;
        $ctrl.bounds.top = 0;
        $ctrl.bounds.bottom = 0;
        $ctrl.caption = '';
        $ctrl.description = '';
        var albumInfoEntity;
        $ctrl.editMode = false;
        $ctrl.uploadImage = uploadImage;
        $ctrl.croppedDataUrl = '';
        $ctrl.croppedThumbDataUrl = '';
        $ctrl.sizeType = this.sizeType || 'CLIENT_SIZE';
        $ctrl.imageList = [];
        $ctrl.islargeFile = false;


        $ctrl.handleFileSelect = function (file) {

            $ctrl.islargeFile = false;
            var MAX_SIZE = 2048000;
            if (!file)
                return;

            if (file && file.size > MAX_SIZE) {
                $ctrl.islargeFile = true;
                $ctrl.file = null;
                if ($ctrl.cropper)
                    $ctrl.cropper.destroy();
                return;
            }

            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $ctrl.file = evt.target.result;
                    if ($ctrl.file.size > 2048) {
                        console.log("majid");
                        return;
                    }

                    var img = document.createElement("img");
                    img.onload = function (event) {
                        // Dynamically create a canvas element
                        var canvas = document.createElement("canvas");

                        // var canvas = document.getElementById("canvas");
                        var ctx = canvas.getContext("2d");


                        var imgWidth = img.width;
                        var imgHeight = img.height;


                        var ratioW = $ctrl.cropWidth / imgWidth;
                        var ratioH = $ctrl.cropHeight / imgHeight;

                        var ratio = Math.max(ratioH, ratioW);

                        if (ratio > 1) {
                            imgWidth = imgWidth * ratio;
                            imgHeight = imgHeight * ratio;
                        }

                        if (ratio < 0.5) {
                            imgWidth = imgWidth * (ratio + 0.05);
                            imgHeight = imgHeight * (ratio + 0.05);
                        }

                        canvas.width = imgWidth;
                        canvas.height = imgHeight;

                        // Actual resizing
                        ctx.drawImage(img, 0, 0, imgWidth, imgHeight);

                        // Show resized image in preview element
                        var dataurl = canvas.toDataURL($ctrl.file.type);
                        document.getElementById("original-image").src = dataurl;


                        // document.getElementById("image-preview").src = dataurl;

                    }
                    img.src = evt.target.result;


                });
            };
            reader.readAsDataURL(file);
            setTimeout(initCropper, 1000);
        };

        function cropImage() {
            var canvas = $ctrl.cropper.getCroppedCanvas();
            var croppedDataUri = canvas.toDataURL("image/jpeg", 0.9);
            $ctrl.croppedDataUrl = croppedDataUri;
        }


        var imageList = [];
        $scope.$watch('$ctrl.albumId', function (albumId) {
            if ($ctrl.albumId) {

                $ctrl.albumInfoEntity = AlbumInfo.get({id: $ctrl.albumId});
                //$ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumId).query();
                $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
            }

        });


        $ctrl.currentImage = {};
        $ctrl.addImage = function () {
            $ctrl.editMode = true;
        }

        function initCropper() {
            var imageElem = document.getElementById('original-image');

            var croppedWidth = $ctrl.cropWidth;
            var croppedHeight = $ctrl.cropHeight;

            var minCroppedWidth = $ctrl.cropWidth - 1;
            var minCroppedHeight = $ctrl.cropHeight - 1;

            if ($ctrl.cropper)
                $ctrl.cropper.destroy();

            $ctrl.cropper = new Cropper(imageElem, {
                // aspectRatio: 1 / 2,
                movable: false,
                zoomable: false,
                rotatable: false,
                scalable: false,
                cropBoxResizable: false,
                viewMode: 2,
                // data: {
                //     width: $ctrl.minWidth + padding,
                //     height: $ctrl.minHeight + padding,
                // },

                crop: function (event) {
                    var width = event.detail.width;
                    var height = event.detail.height;

                    if (
                        width < minCroppedWidth
                        || height < minCroppedHeight
                        || width > croppedWidth
                        || height > croppedHeight
                    ) {
                        $ctrl.cropper.setData({
                            width: Math.max(minCroppedWidth, Math.min(croppedWidth, width)),
                            height: Math.max(minCroppedHeight, Math.min(croppedHeight, height)),
                        });
                    }

                }
            });
        }

        $ctrl.canBeAdded = function () {
            if ($ctrl.imageList)
                return ($ctrl.imageList.length >= $ctrl.maxImageCount);
            return false;
        }
        $ctrl.cancelEditing = function () {
            $ctrl.file = null;
            $ctrl.editMode = false;
        }
        $ctrl.deleteImage = function (img) {

            ImageData.delete({id: img.id},
                function () {
                    if ($ctrl.albumId)
                        $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                });
        }
        $ctrl.imagesrc = function (img) {
            //
            return DataUtils.imagesrc(img.fileDataContentType, img.fileData);
        }

        function addImage() {

        }

        function save() {
            $ctrl.isSaving = true;

            if ($ctrl.albumInfoEntity.id !== null) {
                AlbumInfo.update($ctrl.albumInfo);
            } else {
                AlbumInfo.save($ctrl.albumInfo, function (d) {
                    $ctrl.albumInfoEntity = d;
                });
            }
        }

        function uploadImage() {


            if (!($ctrl.albumInfoEntity && $ctrl.albumInfoEntity.id)) {
                albumInfoEntity = {caption: $ctrl.albumCaption};
                AlbumInfo.save(albumInfoEntity, function (d) {
                    $ctrl.albumInfoEntity = d;
                    $ctrl.albumId = d.id;
                    saveImage();
                }, function (e) {
                    //console.log(e)
                });

            } else {
                saveImage();
            }

        }

        function saveImage() {

            cropImage();

            var imageToUpload = {
                caption: $ctrl.caption,
                description: $ctrl.description,
                albumInfoId: $ctrl.albumInfoEntity.id
            }
            imageToUpload.sizeType = $ctrl.sizeType;

            if (!$ctrl.disableCropping) {
                imageToUpload.fileData = $ctrl.croppedDataUrl.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.croppedThumbDataUrl.split(',')[1];
            } else {
                console.log('not cropped');
                console.log($ctrl.file);
                imageToUpload.fileData = $ctrl.file.split(',')[1];
                imageToUpload.fileDataContentType = 'image/jpeg';
                imageToUpload.thumbnailData = $ctrl.file.split(',')[1];
            }

            ImageDataExtended.uploadImage().save(imageToUpload, function (imageData) {
                if ($ctrl.albumInfoEntity.id) {
                    // $ctrl.imageList = AlbumInfoExtend.findAlbumImages($ctrl.albumInfoEntity.id).query();
                    $ctrl.imageList = AlbumInfoExtend.findAlbumImagesByType($ctrl.albumId, $ctrl.sizeType).query();
                    $ctrl.editMode = false;
                    $ctrl.file = null;
                    if ($ctrl.onImageUploaded) {
                        $ctrl.onImageUploaded(imageToUpload);
                    }
                }
            });
        }

        $ctrl.chooseImage = function () {
            document.getElementById('fileSelector').click();
        }


    }


    var ImageGalleryManagerV2 = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/image-gallery-manager-v2/eyeson.image-gallery-manager-v2.html',
        controller: ImageGalleryManagerV2Controller,
        bindings: {
            label: '<',
            albumId: '=',
            albumCaption: '<',
            cropWidth: '<?',
            cropHeight: '<?',
            minWidth: '<?',
            minHeight: '<?',
            maxImageCount: '<?',
            disableCropping: '<?',
            keepAspect: '<?',
            onImageUploaded: '=?',
            sizeType: '<?'
            /*  items :'<',
             displaytag:'@?',
             displayitem:'@?',
             list:'='*/

        }

    };

    angular
        .module('tikonApp')
        .component('eoImageGalleryManagerV2', ImageGalleryManagerV2)


})();

